/* eslint-disable max-len */
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Container, Dimmer, Grid, Loader } from 'semantic-ui-react';
import { namespaces, TRANSLATION_FILES } from '../../../constants/translation';
import GridDivider from '../../../components/UpdatedComponents/Basic/UCBGridDivider';
import PurchaserSection from './PurchaserSection';

class Purchaser extends Component {
  static propTypes = {
    data: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    loading: PropTypes.bool,
    t: PropTypes.func,
    token: PropTypes.string,
  }

  static getPropsToState = (props) => {
    let data = props.data;
    if (Array.isArray(data)) {
      data = data[0];
    }
    return { data, loading: props.loading };
  }

  static getDerivedStateFromProps(props) {
    return Purchaser.getPropsToState(props);
  }

  constructor(props) {
    super(props);
    this.state = Purchaser.getPropsToState(props);
  }

  render() {
    const { t, token } = this.props;
    const { data, loading } = this.state;
    const primaryCustomer = _.get(data, 'primary_customer', null);
    const secondaryCustomers = _.get(data, 'customers', []);
    const hasSecondary = secondaryCustomers.length > 0;
    return (
      <Container>
        <Grid>
          <Dimmer style={{ zIndex: 10 }} active={loading} inverted>
            <Loader inline="centered">{t('Loading', { ns: TRANSLATION_FILES.translation })}</Loader>
          </Dimmer>
          <Grid.Row>
            <Grid.Column className="opportunity-detail-fields">
              <Grid>
                {/* Page Title */}
                <Grid.Row className="uc-grid-title-row">
                  <Grid.Column width={16}>
                    {t('Purchaser Details', { ns: TRANSLATION_FILES.screens })}
                  </Grid.Column>
                </Grid.Row>

                <PurchaserSection
                  customerId={_.get(data, 'primary_customer_id')}
                  contact={_.get(primaryCustomer, 'contact', {})}
                  token={token}
                  label={hasSecondary ? t('Primary Purchaser', { ns: TRANSLATION_FILES.screens }) : null}
                />

                {secondaryCustomers.map((customer, index) => (
                  <React.Fragment key={customer.id || index}>
                    <GridDivider />
                    <PurchaserSection
                      customerId={customer.id}
                      contact={customer.contact || {}}
                      token={token}
                      label={`${t('Purchaser', { ns: TRANSLATION_FILES.screens })} ${index + 2}`}
                    />
                  </React.Fragment>
                ))}
              </Grid>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Container>
    );
  }
}

export default withTranslation(namespaces)(Purchaser);



// WEBPACK FOOTER //
// ./src/containers/Opportunities/Overview/Purchaser.jsx